<template>
  <div>
    <ul class="sidebar-menu">
      <li>
        <router-link
          :class="{ a_bg: active === 'xwgg' }"
          :to="{
            path: 'list',
            query: { newstype: 'xwgg' }
          }"
        >
          <span>新闻公告</span>
        </router-link>
      </li>
      <li>
        <router-link
          :class="{ a_bg: active === 'szdt' }"
          :to="{
            path: 'list',
            query: { newstype: 'szdt' }
          }"
        >
          <span>市州动态</span>
        </router-link>
      </li>
      <li>
        <router-link
          :class="{ a_bg: active === 'jycy' }"
          :to="{
            path: 'list',
            query: { newstype: 'jycy' }
          }"
        >
          <span>就业创业</span>
        </router-link>
      </li>
      <!-- <li
        v-for="(item, index) in category"
        :key="index"
        v-if="item.category_id === 63"
      >
        <router-link
          :class="{ a_bg: active == item.category_id }"
          :to="{
            path: 'list',
            query: { newstype: 'news', nav: item.category_id.toString() }
          }"
        >
          <span>{{ item.title }}</span>
        </router-link>
      </li> -->
    </ul>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'listCategory',
  props: {
    active: {
      type: String,
      default: 'xwgg'
    }
  },
  data() {
    return {
      category: []
    }
  },
  created() {
    // request.get('/category/list').then(response => {
    //   if (response.data.code === 200) {
    //     let list = response.data.data
    //     list.forEach(elem => {
    //       switch (elem.title) {
    //         case '职业指导':
    //           Object.assign(elem, {
    //             translate: 'Vocational Guidance',
    //             color: 'olive'
    //           })
    //           break
    //         case '职场热点':
    //           Object.assign(elem, {
    //             translate: 'Hot Informations',
    //             color: 'violet'
    //           })
    //           break
    //         case '政策法规':
    //           Object.assign(elem, {
    //             translate: 'Policies and Laws',
    //             color: 'purple'
    //           })
    //           break
    //         case '人才分析':
    //           Object.assign(elem, {
    //             translate: 'Talent Analysis',
    //             color: 'sea'
    //           })
    //           break
    //         default:
    //           break
    //       }
    //     })
    //     this.category = list
    //   }
    // })
  }
}
</script>

<style lang="scss" scoped>
@import url('../../styles/main.scss');
</style>
<style lang="scss">
.el-menu {
  border-right: none;
}

.el-pagination {
  span,
  button {
    height: 28px !important;
    line-height: 28px !important;
  }
}

.el-pager {
  li {
    height: 28px !important;
    line-height: 28px !important;
    border-bottom: none !important;
    width: 28px !important;
    margin: 0 5px;
    background: #f4f4f5 !important;
  }

  li:hover {
    border-bottom: none !important;
    background: none !important;
  }
}

.wenZhang {
  min-height: 300px;
}

.bottom-btn-area {
  position: absolute !important;
  height: 60px !important;
  width: inherit !important;
  bottom: 0;
}

.bottom-btn-area {
  height: inherit !important;
  width: inherit !important;
}

.content {
  display: block;
  position: relative;
  height: auto !important;
  margin: auto auto 80px auto !important;
  width: 100% !important;

  p {
    line-height: 2rem;
    text-indent: 0;
    color: #000;
  }

  a {
    line-height: 2rem;
    text-indent: 0;
    color: #0000ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/list/listCategory.vue